<template>
  <div class="home-block">
    <home-block-title
      title="通知公告"
      linkText="更多"
      :link="{ name: '学院介绍', query: { tab: '3' } }"
    />

    <div class="list notice-list">
      <div class="item" v-for="(item, index) in list" :key="index">
        <div class="left" @click="showInfo(item)">
          <div class="text">
            {{ menuIdToStr(item.menuId) }}{{ item.listTitle }}
          </div>
        </div>
        <div class="right">
          {{ formatDate(item.infoTime, "Y-M-D") }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import homeBlockTitle from "./home-block-title.vue"
  import { getNewsByType } from "@/api/home"
  export default {
    components: { homeBlockTitle },
    data() {
      return {
        list: []
      }
    },
    created() {},
    mounted() {
      this.load()
    },
    methods: {
      load() {
        this.request()
      },
      request() {
        getNewsByType([1, 2]).then((res) => {
          let list = res.data.data || []
          list = list.slice(0, 9)
          this.list = list
        })
      },
      formatDate(date, format) {
        var d = new Date(date)
        var map = {
          Y: d.getFullYear(),
          M: d.getMonth() + 1,
          D: d.getDate(),
          hh: d.getHours(),
          mm: d.getMinutes(),
          ss: d.getSeconds()
        }

        // 从左边补齐二位
        for (var f2 in map) {
          map[f2] = map[f2].toString().padStart(2, "0")
        }

        for (var f1 in map) {
          format = format.replace(f1, map[f1])
        }
        return format
      },

      showInfo(item) {
        const apiUrl = `/web/consult/setting/get/one?id=${item.id}`
        const r = {
          path: "/commonShow",
          query: {
            // 数据源
            apiUrl: apiUrl,

            // 面包屑 第二级菜单
            localActiveParentMenu: "校园新闻",

            // 面包屑 第三级菜单
            localActiveMenu: "通知公告",

            f: 1
          }
        }

        this.$router.push(r)
      },

      menuIdToStr(menuId) {
        const map = {
          1: "信息公开",
          2: "通知公告"
        }
        return `【${map[menuId]}】`
      }
    }
  }
</script>

<style scoped lang="scss">
  .notice-list {
    padding: 20px 20px;
    gap: 0px;
    grid-template-rows: repeat(auto-fill, 60px);
    .item {
      font-size: 20px;
      font-weight: 600;
      color: #292929;

      line-height: 60px;

      border-bottom: 1px solid #d9d9d9;

      &:last-child {
        border-bottom: 0;
      }
    }
  }
</style>
